<template>
    <router-view v-if="faqLoaded"></router-view>
</template>

<script>
export default {
    name: 'Faq',
    created() {
        this.$store.dispatch('faq/fetchAnswers');
        this.$store.dispatch('faq/fetchCategories');
    },
    computed: {
        faqLoaded() {
            return this.$store.getters['faq/getCategories'].length && this.$store.getters['faq/getAnswers'].length;
        },
    },
};
</script>
